<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :class="svgClass"
    :width="width"
    :height="height"
    role="presentation"
  >
      <!-- :viewBox="`0 0 ${width} ${height}`" -->
      <component :is="icon" :fill="colour"></component>
  </svg>
</template>

<script>
import IconVerified from "./IconVerified.vue";
import IconError from "./IconError.vue";
import IconActiveState from "./IconActiveState";
import CheckedStepIcon from "./CheckedStepIcon";
import InsuranceDocumentClose from "./InsuranceDocumentClose.vue";
import UploadDocumentButton from "./UploadDocumentButton.vue";
export default {
  name: "SvgIcons",
  components: {
    IconVerified, IconError, IconActiveState, CheckedStepIcon, InsuranceDocumentClose, UploadDocumentButton
  },
  props: {
    icon: String,
    svgClass: {
      type: String,
      default: '',
    },
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
    colour: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>